export default "__VITE_ASSET__DlMonfL9__"